import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_SURVEY_HISTORY_EDIT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_SURVEY_HISTORY_EDIT_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_SURVEY_HISTORY_EDIT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/user-survey-histories/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
